// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button-m_wukUPM8hCEDu3pjbcset {
  min-width: 7rem;
  font-weight: bold;
  padding: 0.5rem;
  margin-left: 1rem;
  border: 0;
  border-radius: 5px;
  cursor: pointer;
}

.Button-m_wukUPM8hCEDu3pjbcset:hover {
  filter: brightness(1.2);
}

.Button-m_wukUPM8hCEDu3pjbcset:active {
  filter: brightness(0.8);
}

.Button-m_SBDtw6H3OLIbUs48k9nP {
  cursor: not-allowed;
  filter: brightness(0.8);
}

.Button-m_wukUPM8hCEDu3pjbcset.Button-m_SBDtw6H3OLIbUs48k9nP:hover, .Button-m_wukUPM8hCEDu3pjbcset.Button-m_SBDtw6H3OLIbUs48k9nP:active {
  filter: brightness(0.8);
}

.Button-m_DqU1I_64UzdOpMXTHwNy {
  background-color: var(--pps-blue);
  color: white;
}

.Button-m_cvzHrPRdkI2Qm7VArSwf {
  background-color: var(--warn);
  color: white;
}

.Button-m_vTbMG1qMDJipPaJ26vZg {
  background-color: var(--error);
  color: white;
}

.Button-m__zdjT19r5koXOmCAkuvu {
  background-color: var(--success);
  color: white;
}

.Button-m_vv4HeylVdMrbiuWEiQs4 {
  background-color: var(--pies-darkgrey);
  color: var(--text-white);
}

.Button-m_u9JSQVdjXBKMHI8LqWqd {
  background-color: var(--text-white);
  color: var(--pps-blue);
}`, "",{"version":3,"sources":["webpack://./client/shared/genericComponents/Button/Button.m.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;AACxB","sourcesContent":[".button {\n  min-width: 7rem;\n  font-weight: bold;\n  padding: 0.5rem;\n  margin-left: 1rem;\n  border: 0;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.button:hover {\n  filter: brightness(1.2);\n}\n\n.button:active {\n  filter: brightness(0.8);\n}\n\n.disabled {\n  cursor: not-allowed;\n  filter: brightness(0.8);\n}\n\n.button.disabled:hover, .button.disabled:active {\n  filter: brightness(0.8);\n}\n\n.blue {\n  background-color: var(--pps-blue);\n  color: white;\n}\n\n.yellow {\n  background-color: var(--warn);\n  color: white;\n}\n\n.red {\n  background-color: var(--error);\n  color: white;\n}\n\n.green {\n  background-color: var(--success);\n  color: white;\n}\n\n.grey {\n  background-color: var(--pies-darkgrey);\n  color: var(--text-white);\n}\n\n.white {\n  background-color: var(--text-white);\n  color: var(--pps-blue);\n}"],"sourceRoot":""}]);
// Exports
export var button = `Button-m_wukUPM8hCEDu3pjbcset`;
export var disabled = `Button-m_SBDtw6H3OLIbUs48k9nP`;
export var blue = `Button-m_DqU1I_64UzdOpMXTHwNy`;
export var yellow = `Button-m_cvzHrPRdkI2Qm7VArSwf`;
export var red = `Button-m_vTbMG1qMDJipPaJ26vZg`;
export var green = `Button-m__zdjT19r5koXOmCAkuvu`;
export var grey = `Button-m_vv4HeylVdMrbiuWEiQs4`;
export var white = `Button-m_u9JSQVdjXBKMHI8LqWqd`;
export default ___CSS_LOADER_EXPORT___;
